import {
  buildMinerUDiscoveryRequestV913,
  getMinerUModelsV913,
  isMinerUChannelV913,
} from './mineruConfigV913';

export function isSuccessfulModelDiscoverySourceV816(source) {
  return source === 'dynamic';
}

export function hasImportableDiscoveredModelsV816(data) {
  return Array.isArray(data?.models) && data.models.length > 0;
}

export function getDefaultChannelModelsV816(type, models, config = {}) {
  if (isMinerUChannelV913(type)) return getMinerUModelsV913(config);
  return Number(type) === 53 ? [] : models || [];
}

export function buildChannelModelDiscoveryRequestV816({
  isEdit,
  channelId,
  type,
  baseURL,
  keyValues = [],
  config = {},
}) {
  if (isMinerUChannelV913(type)) {
    return buildMinerUDiscoveryRequestV913(baseURL, config);
  }
  if (isEdit) {
    const parsedChannelId = Number(String(channelId));
    if (!Number.isInteger(parsedChannelId) || parsedChannelId <= 0) {
      throw new Error('A saved channel ID is required for model discovery.');
    }
    return { channel_id: parsedChannelId };
  }

  return {
    type,
    base_url: baseURL,
    key: keyValues[0],
    keys: keyValues,
    config,
  };
}
